<template>
  <a-form-item
    v-if="data"
    class="address"
    style="margin-right: 0;"
  >
    <div
      v-decorator="[
        fieldkey,
        {
          initialValue: defaultvalue
        }
      ]"
      class="wrap"
    >
      <div class="code-line">
        <linkage
          v-if="showtype===1 || showtype===2 "
          :default-value="routes"
          :get-data="getData"
          :search-data="searchData"
          :report-search="reportSearch"
          :has-child="item => item.haschildren !== 0"
          :language="language"
          @change="completeHandle"
        >
          <div class="select-box mrt">
            <a-input
              read-only
              :value="codeDesc"
              :placeholder="placeholder"
              :show-search="showSearch"
            />
            <i
              slot="icon"
              class="iconfont iconicon-test19"
            />
          </div>
        </linkage>
      </div>
      <div
        v-if="showtype===1 || showtype===3 "
        style="display:inline-block;"
      >
        <!-- :placeholder="`请输入${data.fieldname}`" -->
        <a-input
          v-if="enableinput"
          :value="defaultvalue.address"
          :placeholder="addressPlaceholder"
          style="display:inline-block; width: 329px;"
          @change="inputChangeHandle"
        />
      </div>
    </div>
  </a-form-item>
</template>

<script>
import Linkage from '@/components/pc/Linkage'
import { getArea, SearchArea, addAreaSearchLog } from '@/services/index'
import { mapState } from 'vuex'
export default {
  name: 'Area',
  components: {
    Linkage
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      routes: [],
      visible: false,
      defaultvalue: this.data.defaultvalue || {}
    }
  },
  computed: {
    ...mapState('universalForm/form', ['payloadDatas']),
    codeDesc () {
      return this.routes.map(item => item.name).join(' / ')
    },
    fieldconfig () {
      const { fieldconfig = {} } = this.data
      return fieldconfig
    },
    enableinput () {
      const { enableinput = true } = this.fieldconfig
      return enableinput
    },
    showtype () {
      const { format = 1 } = this.fieldconfig
      return format
    },
    language () {
      const { deploy = {} } = this.payloadDatas
      const { config = {} } = deploy
      return config.language
    },
    showSearch () {
      const { showSearch = true } = this.fieldconfig
      return showSearch
    },
    fieldkey () {
      return this.data.fieldkey
    },
    isneeded () {
      return this.data.isneeded === 1
    },
    addressPlaceholder () {
      return this.$t('message["813"]')
    }
  },
  watch: {
    data: {
      handler (val) {
        this.routes = []
        this.init()
      },
      // deep: true,
      immediate: true
    }
  },
  methods: {
    init () {
      const { defaultvalue = {} } = this.data
      // fix-start: 当fieldvalue为空时后端返回的是[],因此需要下面特殊处理依稀
      const value = {
        code: defaultvalue.code || {},
        address: defaultvalue.address || ''
      }
      this.data.defaultvalue = value
      this.defaultvalue = value
      // fix-end
      const { code = {} } = this.data.defaultvalue
      this.routes = Object.keys(code).map(key => {
        return {
          code: key,
          name: code[key]
        }
      })
    },
    validatedCallback (err, values) {
      if (!err) {
        this.$emit('change', this.defaultvalue)
      }
    },
    inputChangeHandle (e) {
      // console.log('input value: ', e.target.value)
      const { defaultvalue } = this
      defaultvalue.address = e.target.value
      this.data.defaultvalue.address = e.target.value
      // this.myForm.setFieldsValue({
      //   [fieldkey]: fieldvalue
      // })
      // this.myForm.validateFields([fieldkey], this.validatedCallback)
    },
    completeHandle (routes) {
      const { defaultvalue } = this
      this.routes = routes
      // console.log(routes)
      const codes = {}
      routes.forEach((item) => {
        const { code, name } = item
        codes[code] = name
      })
      defaultvalue.code = codes
      this.data.defaultvalue.code = codes
      // this.myForm.setFieldsValue({
      //   [fieldkey]: fieldvalue
      // })
      // this.myForm.validateFields([fieldkey], this.validatedCallback)
    },

    async getData ({ level, data, language }) {
      const chain = await getArea()
      const params = {}
      if (data) {
        params.code = data.code
        params.fieldkey = this.data.fieldkey
      } else {
        params.fieldkey = this.data.fieldkey
      }
      params.language = language
      return new Promise(async (resolve, reject) => {
        await chain
          .params(params)
          .onSuccess(payload => {
            const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async searchData ({ keyword, language }) {
      const chain = await SearchArea()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            keyword,
            fieldkey: this.data.fieldkey,
            language
          })
          .onSuccess(payload => {
            const arr = payload.map(item => {
              return Object.keys(item).map(code => {
                return {
                  code,
                  name: item[code]
                }
              })
            })
            // const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async reportSearch (value) {
      const chain = await addAreaSearchLog()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            name: value
          })
          .onSuccess(payload => {
            resolve(true)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.code-line {
  margin-bottom: 24px;
  display: inline-block;
}
.select-box {
  position: relative;
  width: 200px;
  .iconfont {
    position: absolute;
    right: 8px;
    color: $gray3;
  }
  .ant-input{
    width: 200px;
  }
}
</style>
<style lang="scss">
.area-pover {
  width: 320px;
  padding-top: 0;
  .ant-popover-arrow {
    display: none;
  }
  .ant-popover-inner-content {
    padding: 0;
  }
}
</style>
